import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import Moment from 'react-moment';
import {Container, Row, Col } from "shards-react";

import Modal from 'react-bootstrap/Modal'

import { NOTIFICATIONS_EVENTS_LIST_OPTIONS } from "../../core/constants";
import { getNotificationById } from "../../core/notifications";
import { orderListActions } from "../../core/orders-lists";

class NotificationViewModal extends React.Component {

  render() {
    const { show, notificationId, notification, navigateToOrder } = this.props

    if ( !notification )
      return null;

    const event = NOTIFICATIONS_EVENTS_LIST_OPTIONS.find( event => event.id === notification.evento );

    return (
      <Modal

        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2500 }}
        onHide={() => this.props.handleClose() }
      >
      <Modal.Header closeButton style={{ borderBottom: 'none',  paddingBottom: '0px' }}>
         <h5 className="m-0">
            <span>{event.label}</span>
         </h5>
       </Modal.Header>
       <Modal.Body style={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0 }}>
        <Container fluid className="main-content-container px-4">
          <Row className="py-3 mb-4">
            <Col >
              <Container fluid className="px-3 pt-2 border-top detalle-header" >
                <Row >
                  <Col className="text-right">
                       <small className="text-reagent-gray">{ notification.dtCreated !== '0001-01-01T00:00:00' ? <Moment date={notification.dtCreated} format="DD/MM/YYYY H:mm" /> : '' }</small>
                  </Col >
               </Row >
               <Row >
                <p className="px-3">{notification.mensaje}</p>
               </Row >
               <Row >
                <div className="blog-comments__actions">
                  <div className="btn-group-sm btn-group">
                    { !!notification.ordenId && <button onClick={ ()=>navigateToOrder(notification.ordenId) } className="btn btn-white"> Orden {notification.ordenNro}</button> }                    
                  </div>
                </div>
                </Row>
               </Container>
             </Col>
           </Row>
         </Container>
        </Modal.Body>
      </Modal>
    );
  }
}

NotificationViewModal.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,

};

NotificationViewModal.defaultProps = {
  title: "Detalle Notifiacion",
  internacion: null
};

//export default InternacionDetalleModal;


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {

  const notification = getNotificationById(state, props.notificationId )
  return {
    notification,
  };
};

const mapDispatchToProps = {
  navigateToOrder: orderListActions.navigateToOrder
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationViewModal);
